<script setup lang="ts">

interface ShopProps {
  id:number;
  name: string;
  type: string;
  address: string;
  bannerUrl: string;
  openTime?: string | null;
  closeTime?: string | null;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<ShopProps>(), {
  openTime: "N/A",
  closeTime: "N/A",
});
</script>

<template>
    <div class="bg-base-100 border border-base-200">
        <figure class="h-40 w-full overflow-hidden relative">
            <img
            :src="bannerUrl"
            :alt="name"
            class="object-cover w-full h-full transition-transform duration-500 hover:scale-110" >
            <!-- <div class="absolute top-3 right-3 badge badge-success text-white font-medium border-none">
            Open Now
            </div> -->
        </figure>

        <div class="card-body">
            <div class="flex justify-between items-start">
            <h2 class="card-title text-xl font-bold text-primary">{{name}}</h2>
            <div class="badge badge-sm badge-primary badge-outline">{{type}}</div>
            </div>

            <div class="flex items-start gap-2 text-base-content/70 mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 mt-1 shrink-0 text-primary">
                <path fill-rule="evenodd" d="M9.69 18.933l.003.001C9.89 19.02 10 19 10 19s.11.02.308-.066l.002-.001.006-.003.018-.008a5.741 5.741 0 00.281-.14c.186-.096.446-.24.757-.433.62-.384 1.445-.966 2.274-1.765C15.302 14.988 17 12.493 17 9A7 7 0 103 9c0 3.492 1.698 5.988 3.355 7.584a13.731 13.731 0 002.273 1.765 11.842 11.842 0 00.976.544l.062.029.018.008.006.003zM10 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z" clip-rule="evenodd" />
            </svg>
            <p class="text-sm">{{ address }}</p>
            </div>
            <div class="flex items-center gap-2 font-semibold">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 text-primary">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span class="font-bold">{{ openTime }}</span> - <span class="font-bold">{{ closeTime }}</span>
            </div>
        </div>
    </div>
</template>